export var ValidationStatus;
(function (ValidationStatus) {
    ValidationStatus["INITIALIZING"] = "INITIALIZING";
    ValidationStatus["NO_FACE_DETECTED"] = "NO_FACE_DETECTED";
    ValidationStatus["FACE_DETECTED"] = "FACE_DETECTED";
    ValidationStatus["TOO_CLOSE"] = "TOO_CLOSE";
    ValidationStatus["TOO_FAR"] = "TOO_FAR";
    ValidationStatus["OFF_CENTER"] = "OFF_CENTER";
    ValidationStatus["FACE_OBSTRUCTED"] = "FACE_OBSTRUCTED";
    ValidationStatus["HEAD_NOT_STRAIGHT"] = "HEAD_NOT_STRAIGHT";
    ValidationStatus["MULTIPLE_FACES"] = "MULTIPLE_FACES";
    ValidationStatus["POOR_ILLUMINATION"] = "POOR_ILLUMINATION";
    ValidationStatus["NOT_NEUTRAL_EXPRESSION"] = "NOT_NEUTRAL_EXPRESSION";
    ValidationStatus["DARK_GLASSES"] = "DARK_GLASSES";
    ValidationStatus["STAY_STILL"] = "STAY_STILL";
    ValidationStatus["CAPTURING"] = "CAPTURING";
    ValidationStatus["SUCCESS"] = "SUCCESS";
    ValidationStatus["ERROR"] = "ERROR";
})(ValidationStatus || (ValidationStatus = {}));
